import { Breadcrumb, Button, Card, Col, Form, Input, message, Popconfirm, Row, Table } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import gql from 'graphql-tag';
import React, { Component, FormEvent } from 'react';
import { Mutation, Query } from 'react-apollo';
import { Link, RouteComponentProps } from 'react-router-dom';
import { client } from 'src/services/api';
import { mobileMasking, nameMasking } from 'src/utils/masking';

import { Panel } from '../../components/Panel';
import { WORKERS_QUERY } from './constant';
import { EditWorker } from './EditWorker';
import { Role, Worker } from './type';

interface State {
  allUserRoles?: Role[];
  currentPage: number;
  variables: {
    ids?: number[];
    name?: string;
    mobile?: string;
    isWorker: boolean;
  };
}

interface Props {
  form: WrappedFormUtils;
}
type AllProps = RouteComponentProps & Props;

const userRolesQuery = gql`
  query userRoles {
    userRoles {
      id
      name
    }
  }
`;

const deleteWorkerUserMutation = gql`
  mutation deleteWorkerUser($id: ID!) {
    deleteWorkerUser(id: $id) {
      id
    }
  }
`;

export class WorkerListForm extends Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props);
    this.state = {
      currentPage: 1,
      variables: { isWorker: true },
    };
    this.search = this.search.bind(this);
    this.onResetClick = this.onResetClick.bind(this);
  }

  async componentDidMount() {
    try {
      const response = await client.query<{ userRoles: Role[] }>({
        query: userRolesQuery,
      });
      const { userRoles = [] } = response.data || {};
      if (userRoles) {
        this.setState({
          allUserRoles: userRoles,
        });
      }
    } catch (error) {
      message.error(`${error.message}`);
    }
  }

  search = (e: FormEvent) => {
    const variables: {
      ids?: number[];
      name?: string;
      mobile?: string;
      isWorker: boolean;
    } = { isWorker: true };
    this.props.form.validateFields((err, values) => {
      if (err) {
        message.error(err);
        return;
      }
      const { id, name, mobile } = values;
      if (id && id !== '') {
        variables.ids = [id];
      }
      if (name && name !== '') {
        variables.name = name;
      }
      if (mobile && mobile !== '') {
        variables.mobile = mobile;
      }
      this.setState({
        variables,
      });
    });

    e.preventDefault();
  };

  onResetClick = () => {
    this.props.form.resetFields();
  };

  onPageChange = (currentPage: number) => {
    this.setState({
      currentPage,
    });
  };

  render() {
    const { allUserRoles, currentPage, variables } = this.state;
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>员工列表</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
          <Form onSubmit={this.search}>
            <Row gutter={24} type={'flex'} align={'middle'}>
              <Col span={8}>
                <Form.Item label={`用户ID`}>
                  {getFieldDecorator('id')(<Input placeholder="请输入用户ID" allowClear />)}
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label={`用户微信昵称`}>
                  {getFieldDecorator('name')(<Input placeholder="请输入微信昵称" allowClear />)}
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label={`手机号`}>
                  {getFieldDecorator('mobile')(<Input placeholder="请输入手机号" allowClear />)}
                </Form.Item>
              </Col>
            </Row>
            <Row type="flex" justify="end">
              <Button icon="search" type="primary" style={{ marginRight: 8 }} htmlType="submit">
                搜索
              </Button>
              <Button style={{ marginRight: 8 }} type="primary" onClick={this.onResetClick}>
                重置
              </Button>
            </Row>
          </Form>
        </Card>
        <Panel style={{ marginTop: 10 }}>
          <Query query={WORKERS_QUERY} variables={variables} fetchPolicy="cache-and-network">
            {({ loading, error, data }) => {
              if (error) return <div>{error.message}</div>;
              const { users = [] } = data || {};

              const newUsers = JSON.parse(JSON.stringify(users));
              const maskedMobileUsers: Worker[] = newUsers.map(user => {
                if (user.mobile) {
                  user.mobile = mobileMasking(user.mobile);
                }
                if (user.name) {
                  user.name = nameMasking(user.name);
                }
                return user;
              });

              return (
                <Table<Worker>
                  loading={loading}
                  dataSource={maskedMobileUsers}
                  rowKey={row => `${row.id}`}
                  pagination={{ current: currentPage, onChange: this.onPageChange }}
                >
                  <Table.Column dataIndex="id" title="用户ID" key="id" />
                  <Table.Column dataIndex="name" title="用户名" key="name" />
                  <Table.Column dataIndex="mobile" title="手机号" key="mobile" />
                  <Table.Column
                    width={'40%'}
                    title="角色"
                    dataIndex="roles"
                    key="roles"
                    render={(roles: Role[]) =>
                      roles.map(role => {
                        return (
                          <Button key={role.id} style={{ margin: 5 }} type="dashed">
                            {role.name}
                          </Button>
                        );
                      })
                    }
                  />
                  <Table.Column
                    title="操作"
                    key="actions"
                    render={(record: Worker) => (
                      <>
                        {allUserRoles && (
                          <EditWorker defaultRoles={record.roles} allRoles={allUserRoles} userId={Number(record.id)} />
                        )}
                        <Mutation
                          mutation={deleteWorkerUserMutation}
                          variables={{ id: Number(record.id) }}
                          refetchQueries={[{ query: WORKERS_QUERY, variables: { isWorker: true } }]}
                        >
                          {(deleteWorkerUser, { loading }) => {
                            return (
                              <>
                                <Popconfirm
                                  title="是否确定删除该权限?"
                                  onConfirm={async () => {
                                    try {
                                      await deleteWorkerUser();
                                      message.success('删除成功！');
                                    } catch (error) {
                                      message.error(`${error.message}`);
                                    }
                                  }}
                                >
                                  <Button type="primary" style={{ marginTop: 10 }} loading={loading}>
                                    删除
                                  </Button>
                                </Popconfirm>
                              </>
                            );
                          }}
                        </Mutation>
                      </>
                    )}
                  />
                </Table>
              );
            }}
          </Query>
        </Panel>
      </div>
    );
  }
}
export const WorkerList = Form.create({ name: 'WorkerList' })(WorkerListForm);



// WEBPACK FOOTER //
// ./src/screens/rolePermission/WorkerList.tsx